import { Navigate } from "react-router-dom";
import AccessDenied from "../pages/errorpages/AccessDenied";
import { useCurrentUser } from "../utilities/currentUser";
import { userHasAnyRole } from "../utils/leadershipRoles";

/**
 * Login guard with an optional role check.
 *  - no `allowedRoles`: any logged-in user passes;
 *  - `allowedRoles`: only users holding at least one of those roles pass, everyone else sees
 *    the "no access" page (never a silent redirect).
 * Role-gated routes wait for the first refresh of the user's roles (see refreshCurrentUser)
 * so stale roles from localStorage never flash protected content.
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, ready } = useCurrentUser();
  const token = localStorage.getItem("token");

  if (!token || !user) {
    return <Navigate to="/" replace />;
  }

  const roleGated = Array.isArray(allowedRoles) && allowedRoles.length > 0;
  if (!roleGated) {
    return children;
  }

  if (!ready) {
    return <div className="p-4 text-muted">Loading...</div>;
  }

  if (!userHasAnyRole(user, allowedRoles)) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
